/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    addServiceArea: (data) => {
    return axios.post(API_ENDPOINTS.ADD_SERVICE_AREA, data, {
      headers: { 
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug":"default"
       },
    });
  },
  getServiceArea: (params) => {
    return axios.get(API_ENDPOINTS.GET_SERVICE_AREA, {
      headers: { 
        isAuthRequired: true,
        "Content-Type": "application/json" ,
        "x-tenant-slug":"default"
        },
      params,
    });
  },
  getServiceAreaById: (id) => {
    return axios.get(API_ENDPOINTS.GET_SERVICE_AREA_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json",
        "x-tenant-slug":"default" },
    });
  },
  updateServiceArea: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_SERVICE_AREA + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"},
    });
  },
  deleteServiceAreaById: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_SERVICE_AREA + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"},
    });
  },
  getRestrictedServiceArea: () => {
    return axios.get(API_ENDPOINTS.GET_RESTRICTED_SERVICE_AREA, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"},
    });
  },
  getRestrictedServiceAreaById: (id) => {
    return axios.get(
      API_ENDPOINTS.GET_RESTRICTED_SERVICE_AREA_BY_ID + "/" + id,
      {
        headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      }
    );
  },
  restrictLocationCreate: (data) => {
    return axios.post(API_ENDPOINTS.ADD_RESTRICT_SERVICE_AREA, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  restrictLocationUpdate: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_RESTRICT_SERVICE_AREA + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  restrictLocationDetailsGet: (id) => {
    let url = API_ENDPOINTS.GET_RESTRICTED_DETAILS_BY_ID + "/" + id;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  deleterestrictLocationDetails: (id) => {
    let url = API_ENDPOINTS.DELETE_RESTRICTED_DETAILS_BY_ID + "/" + id;
    return axios.delete(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
};
